import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { composeWithDevTools } from '@redux-devtools/extension'
import { content, authReducer, userReducer, cart, configuration, subscriptionCart } from '@ten24/slatwall-storefront-react-private/reducers'
import devData from './preload'
import { combineReducers } from 'redux'
import * as Sentry from '@sentry/react'
import { ccgApiReducer } from './reducers'

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options
})
const rootReducer = combineReducers({
  content,
  authReducer,
  userReducer,
  cart,
  configuration,
  subscriptionCart,
  ccgApiReducer,
})

const preloadedState = { configuration: devData }
// preloadedState.preload = {...devData,...preloadedState.preload}
// Allow the passed state to be garbage-collected
const store = createStore(rootReducer, preloadedState, composeWithDevTools(applyMiddleware(thunkMiddleware), sentryReduxEnhancer))

export default store